var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"time"},[_c('span',[_vm._v(_vm._s(_vm.initTime))]),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"8px"}},[_vm._v("s")])])}
var staticRenderFns = []

export { render, staticRenderFns }